import request from "./index";

const baseURL = 'http://enterprise.qk-p.com/admin/manage/getContentList?tableName='

export function news(params){
    return request({
        url:baseURL+'news',
        method:'post',
        data:{}
    })
}

export function newsDetail(params){
    return request({
        url:baseURL+'news',
        method:'post',
        data:{
            id:params
        }
    })
}
export function getKnowledgebase(params){
    return request({
        url:baseURL+'knowledgebase',
        // url:'http://192.168.10.48:8080/admin/manage/getContentList?tableName=knowledgebase',

        method:'post',
        data:{}
    })
}






// WEBPACK FOOTER //
// ./src/api/api.js